export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10582.8587dfa2.jpg";